import React from "react";
import "./Checkbox.scss";
import cs from "classnames";

const Checkbox = ({ children, id, checked, onChange, disabled, isPartial }) => {
  return (
    <p className={cs(["checkbox"], { ["isPartial"]: isPartial })}>
      <input
        type="checkbox"
        id={id}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <label htmlFor={id}>
        <span>{children}</span>
      </label>
    </p>
  );
};

export default Checkbox;
